<!-- Convenios Editar -->

<p-panel header="{{ 'CONVENIOS.LBL_CONVENIOS' | translate}}">

  <form [formGroup]="formulario" (ngSubmit)="guardar()" id="formModel" name="formModel" *ngIf="formulario">

    <div class="grid">

      <!-- Numero Contrato -->
      <div class="col-6">
        <div class="div-form">
          <label class="control-label"><strong>* {{ 'CONVENIOS.LBL_NUMEROCONTRATO' | translate }}: </strong></label>
          <input type="text" pInputText id="numeroContrato" name="numeroContrato" formControlName="numeroContrato"
                 [maxLength]="10" codigos-reactive (blur)="validarUnicoCodigo(f.numeroContrato.value)">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.numeroContrato.invalid">
            {{ 'CONVENIOS.LBL_NUMEROCONTRATO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="!codigoValido">
            {{ 'CONVENIOS.LBL_NUMEROCONTRATO' | translate }} {{ 'LBL_INVALIDO' | translate }}
          </div>
        </div>
      </div>

      <!-- Nombre -->
      <div class="col-6">
        <div class="div-form">
          <label class="control-label"><strong>* {{ 'LBL_NOMBRE' | translate }}: </strong></label>
          <input type="text" pInputText id="nombre" name="nombre" formControlName="nombre"
                 [maxLength]="100">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
            {{ 'LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>

      <!-- Fecha Inicio -->
      <div class="col-6">
        <div class="div-form">
          <label class="control-label"><strong>* {{ 'LBL_FECHAINICIO' | translate }}: </strong></label>
          <p-calendar id="fechaDesde" name="fechaDesde" [showIcon]="true" dateFormat="yy'-'mm'-'dd"
                      [maxDate]="configModel.fechaInicioMax"
                      [minDate]="configModel.fechaInicioMin"
                      [monthNavigator]="true" [yearNavigator]="true"
                      [locale]="es" readonlyInput="readonlyInput" [yearRange]="range"
                      dataType="date"
                      (onSelect)="guardarFechaDesde($event)"
                      formControlName="fechaDesde"
                      [hideOnDateTimeSelect]="true"></p-calendar>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaDesde.invalid">
            {{'LBL_FECHAINICIO' | translate}} {{'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>

      <!-- Fecha Fin -->
      <div class="col-6">
        <div class="div-form">
          <label class="control-label"><strong>* {{ 'LBL_FECHAFIN' | translate }}: </strong></label>
          <p-calendar id="fechaHasta" name="fechaHasta" [showIcon]="true" dateFormat="yy'-'mm'-'dd"
                      [maxDate]="configModel.fechaFinMax"
                      [minDate]="configModel.fechaFinMin"
                      [monthNavigator]="true" [yearNavigator]="true"
                      [locale]="es" readonlyInput="readonlyInput" [yearRange]="range"
                      dataType="date"
                      (onSelect)="guardarFechaHasta($event)"
                      formControlName="fechaHasta"
                      [hideOnDateTimeSelect]="true"></p-calendar>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaHasta.invalid">
            {{'LBL_FECHAINICIO' | translate}} {{'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>

      <!-- Opciones Desembolso -->
      <div class="col-6">
        <div class="div-form">
          <label class="control-label"><strong>* {{ 'CONVENIOS.LBL_OPCIONDESEMBOLSO' | translate }}: </strong></label>
          <p-dropdown disableTab  id="idOpcionDesembolso" name="idOpcionDesembolso" [options]="opcionesDesembolsos"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                       formControlName="idOpcionDesembolso"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idOpcionDesembolso.invalid">
            {{'CONVENIOS.LBL_OPCIONDESEMBOLSO' | translate}} {{'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>

      <!-- Indicador Habilitado -->
      <div class="col-6 flex align-items-center">
        <div class="div-form">
          <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true" id="indicadorHabilitado" name="indicadorHabilitado"
                      formControlName="indicadorHabilitado"></p-checkbox>
        </div>
      </div>

      <!-- Guardar -->
      <div class="col-12 form-footer-buttons">
        <div class="form-group" *ngIf="!guardando">
          <a (click)="cancelar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
        </div>

        <div class="form-group " *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-fw"></i>
          <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
        </div>

      </div>

    </div>

  </form>
</p-panel>

<p-confirmDialog #cd key="convenios">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
